import { ICreateEntregaObraClienteArquivoAuxUseCase } from "../../../presentation/useCases/create/create_entrega_obra_cliente_arquivo_aux_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateEntregaObraClienteArquivoAuxUseCase
 */

export class CreateEntregaObraClienteArquivoAuxUseCase implements ICreateEntregaObraClienteArquivoAuxUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObra: number,
    descricao?: string,
    arquivo?: File

  ): Promise<void> {
    const nomeArquivo = arquivo ? arquivo.name : undefined;
    const computedArquivo = arquivo ? arquivo : null;

    await this.repository.createEntregaObrasClienteArquivosAux(
      idEntregaObra,
      nomeArquivo,
      descricao,
      computedArquivo ?? undefined,

    );
  }

}
